module.exports = __webpack_public_path__ + "assets/img/event_banner.fdf3e535.png";